export enum GAME_CATEGORY {
  ALL = 'All Games',
  OTHER_GAMES = 'Other Games',
}

/**
 * 游戏数据类型
 */
export interface GameOption {
  value: string;
  text: string;
  textCn: string;
  categories: string[];
  image?: string; // 游戏图片 URL
}

/**
 * 单个游戏数据类型
 */
export interface GameData {
  game_id: string;
  game_name: string;
  genre: string;
  genre_zh: string;
  cover?: string;
  id_type?: string;
  entity_type?: string;
  release_date?: string;
  has_creative_trends?: boolean;
  has_ugc_trends?: boolean;
}

/**
 * 原始游戏数据类型（从接口获取的数据格式）
 * 支持扁平化的游戏数组
 */
export type RawGameData = GameData[];
